import React from "react";
import { Container } from "reactstrap";
import "../../styles/support.css"

const Support = () => {
  return (
    <Container className="py-5 support-policy">
      <h1>Hướng dẫn mua hàng & Thanh toán</h1>
      <h3>1. Cách thức mua hàng</h3>
      <p>Hiện tại, website chưa hỗ trợ đặt hàng trực tuyến. Quý khách vui lòng liên hệ hotline +(84) 941 604 103 hoặc đến trực tiếp cửa hàng.</p>
      <h3>2. Phương thức thanh toán</h3>
      <p>Quý khách có thể thanh toán bằng tiền mặt khi nhận hàng (Ship COD) hoặc chuyển khoản ngân hàng.</p>
    </Container>
  );
};

export default Support;